// @flow
import React, { Component } from 'react';
import moment from 'moment';
import tz from 'moment-timezone';
import Highlighter from 'react-highlight-words';
import Tooltip from 'react-tooltip';
import {
    Icon,
    Button,
    Checkbox,
    Timer,
    Status,
    ProductNameBox,
    Modal,
    LocaleLink,
} from '../../../common/';
import I18n from '../../../../i18n/I18n';
import Helper from '../../../../helper/Helper';
import styles from './OrderBox.scss';

class OrderBox extends Component {
    state = {
        dialogOpen: false,
    };
    openDialog = () => {
        this.setState({
            dialogOpen: true,
        });
    };

    closeDialog = () => {
        this.setState({
            dialogOpen: false,
        });
    };
    render() {
        const {
            order,
            toggleCheckbox,
            lang,
            currencyCode,
            selectedOrders,
            orderStatus,
            onAcceptOrder,
            sellerCountry,
            fmIntegrated,
            searchString,
            linkOrder,
        } = this.props;

        const newAction = is_accepted => {
            return {
                id_purchase_order_item: order.id_purchase_order_item,
                is_accepted,
            };
        };
        const acceptedAction = is_cancelled => {
            return {
                id_purchase_order_item: order.id_purchase_order_item,
                is_cancelled,
            };
        };

        const isLocaleKsa = sellerCountry && sellerCountry === 'SA';

        const expiry =
            order && order.fulfillment_date
                ? moment.tz(
                      order.fulfillment_date,
                      isLocaleKsa ? 'Asia/Riyadh' : 'Asia/Dubai',
                  )
                : '';

        const Tag = linkOrder ? LocaleLink : `a`;

        const m = expiry ? moment(expiry).format() : '';

        return (
            <div className={styles.ctr}>
                <div>
                    {fmIntegrated &&
                    (orderStatus === 2 || orderStatus === 3) &&
                    !order.is_fbn ? (
                        <div>
                            <Checkbox
                                checked={selectedOrders.includes(
                                    order.id_purchase_order_item,
                                )}
                                onClick={() =>
                                    toggleCheckbox(order.id_purchase_order_item)
                                }
                                name={order.id_purchase_order_item}
                                variant={orderStatus === 3 ? 'warning' : ''}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className={styles.flexer}>
                    <Tag
                        target={!linkOrder && '_blank'}
                        href={
                            !linkOrder
                                ? `${Helper.getAppDomain(
                                      'catalog',
                                  )}/${Helper.getLocale()}/catalog/${
                                      order.psku_canonical
                                  }`
                                : ''
                        }
                        to={
                            linkOrder
                                ? `/orders?search=${
                                      order.item_nr
                                  }&item_status=1`
                                : ''
                        }
                    >
                        <ProductNameBox
                            data={order}
                            searchString={searchString}
                        />
                        {order.status === 'rerequested' ? (
                            <div className={styles.rerequested}>
                                <Icon
                                    name="re-request"
                                    className={styles.rerequestIcon}
                                />
                                {I18n.getText('orders.rerequested-text')}
                                <div data-tip data-for={order.item_nr}>
                                    <Icon
                                        name="tooltip"
                                        className={styles.icon}
                                    />
                                </div>
                                <Tooltip
                                    className={styles.tooltip}
                                    place="right"
                                    type="dark"
                                    effect="solid"
                                    id={order.item_nr}
                                >
                                    <div>
                                        {I18n.getText(
                                            'orders.rerequested-explanation',
                                        )}
                                    </div>
                                </Tooltip>
                            </div>
                        ) : (
                            ''
                        )}
                    </Tag>
                    <div className={styles.statusCtr}>
                        <Status status={order.status} />
                        <div className={styles.date}>
                            {order
                                ? moment(
                                      order.created_at || order.createdAt,
                                  ).format(
                                      `YYYY-MM-DD [${
                                          lang === 'ar' ? '' : 'at'
                                      }] h:mm:ss a`,
                                  )
                                : ''}
                        </div>
                    </div>
                </div>
                <div className={styles.descCtr}>
                    <div className={styles.attrCtr}>
                        {order.item_nr ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('order-details.item-nr')}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={order.item_nr}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {order.partner_sku ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText(
                                        'order-details.p-sku',
                                        {},
                                        'Partner SKU',
                                    )}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={order.partner_sku}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {order.sku ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('order-details.sku')}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={order.sku}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('order-modal.qty')}
                            </h6>
                            <div className={styles.attrVal}>
                                {order.quantity || '1'}
                            </div>
                        </div>
                        {order.warehouse_code ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('orders.warehouse')}
                                </h6>
                                <div className={styles.attrVal}>
                                    {order.warehouse_code || '1'}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('orders.amount', {
                                    currency: currencyCode,
                                })}
                            </h6>
                            <div className={styles.attrVal}>
                                {order.price || ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottomWrapper}>
                    {(orderStatus === 1 &&
                        !order.is_fbn &&
                        order &&
                        order.fulfillment_date) ||
                    (orderStatus === 2 &&
                        !order.is_fbn &&
                        order &&
                        order.fulfillment_date &&
                        fmIntegrated) ? (
                        <div className={styles.timerLabel}>
                            {I18n.getText('orders.fulfilment-promise')} &nbsp;
                            <Timer endDate={m} />
                        </div>
                    ) : (
                        ''
                    )}

                    <div className={styles.btnWrapper}>
                        {(orderStatus === 1 || orderStatus === 2) &&
                        !order.is_fbn ? (
                            <Button
                                className={`${styles.accept} ${styles.flexer}`}
                                variant="transparent"
                                onClick={() => this.openDialog()}
                            >
                                <Icon name="close" className={styles.icon} />
                                <div>
                                    {I18n.getText('order-details.cancel')}
                                </div>
                            </Button>
                        ) : (
                            ''
                        )}
                        {orderStatus === 1 && !order.is_fbn ? (
                            <Button
                                variant="primary"
                                className={`${styles.accept} ${styles.flexer}`}
                                onClick={() => onAcceptOrder(newAction(true))}
                            >
                                <Icon
                                    name="checkmark"
                                    className={styles.icon}
                                />
                                <div>{I18n.getText('order.accept-order')}</div>
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <Modal
                    contentLabel={'deleteConfirm'}
                    isOpen={this.state.dialogOpen}
                    closeModal={() => this.closeDialog()}
                    dialogBox
                    onSubmit={() => onAcceptOrder(newAction(false))}
                    cancelBtnLabel={I18n.getText('orders.close-btn')}
                    warning
                    submitBtnLabel={I18n.getText('product.confirm-btn')}
                    dialogTitle={I18n.getText('orders.confirm-cancel')}
                >
                    <div className={styles.confirmDelete}>
                        <p>
                            {I18n.getText('orders.cancel-confirm', {
                                name: order.title,
                            })}
                        </p>
                        <p>{I18n.getText('orders.cancel-warning')}</p>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default OrderBox;



// WEBPACK FOOTER //
// ./src/components/orders/orderTable/orderBox/OrderBox.js